import React from 'react';
import { SafetyObjective } from '../types';

interface ObjectivesOverviewProps {
  objectives: SafetyObjective[];
  loading: boolean;
  onOpenCreate: () => void;
  onSelectObjective?: (id: string) => void;
}

export const ObjectivesOverview: React.FC<ObjectivesOverviewProps> = ({
  objectives,
  loading,
  onOpenCreate,
  onSelectObjective,
}) => {
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center bg-white p-4 rounded-lg shadow-sm border border-gray-200">
        <div>
          <h2 className="text-lg font-semibold text-gray-800">Safety Objectives (ICAO Annex 19)</h2>
          <p className="text-sm text-gray-500">
            Strategic and operational safety performance objectives defined per SMS continuous improvement requirements.
          </p>
        </div>
        <button
          onClick={onOpenCreate}
          className="btn-primary"
          style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
        >
          <span>+</span>
          <span>New Safety Objective</span>
        </button>
      </div>

      {!loading && objectives.length === 0 ? (
        <div className="p-8 text-center text-gray-500 bg-white rounded-lg border border-dashed border-gray-300">
          No safety objectives registered. Click above to create one.
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {objectives.map((obj) => (
            <div
              key={obj.id}
              onClick={() => onSelectObjective && onSelectObjective(obj.id)}
              className="bg-white p-5 rounded-lg border border-gray-200 hover:border-blue-300 hover:shadow-md transition cursor-pointer flex flex-col justify-between"
            >
              <div>
                <div className="flex items-center justify-between mb-2">
                  <span className="font-mono text-xs font-bold px-2 py-0.5 bg-blue-50 text-blue-700 rounded border border-blue-200">
                    {obj.code}
                  </span>
                  <span
                    className={`text-xs px-2 py-0.5 rounded-full font-medium ${
                      obj.status === 'ACTIVE'
                        ? 'bg-green-100 text-green-800'
                        : obj.status === 'UNDER_REVIEW'
                        ? 'bg-yellow-100 text-yellow-800'
                        : 'bg-gray-100 text-gray-800'
                    }`}
                  >
                    {obj.status}
                  </span>
                </div>
                <h3 className="text-base font-bold text-gray-900 mb-1">{obj.title}</h3>
                <p className="text-sm text-gray-600 line-clamp-3 mb-3">{obj.description}</p>
              </div>

              <div className="pt-3 border-t border-gray-100 flex items-center justify-between text-xs text-gray-500">
                <span className="font-medium text-gray-700">Dept: {obj.department}</span>
                <span>Category: {obj.category}</span>
                <span>Target: {obj.targetDate}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
